import Skeleton from '@mui/material/Skeleton';
import Avatar, { AvatarIcon } from 'components/Avatar';
import { useProfileInfo } from 'state/user';

export interface UserAvatarProps {
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ className }) => {
  const { data: profileData, isError, isLoading } = useProfileInfo();

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <Skeleton variant="circular">
        <AvatarIcon />
      </Skeleton>
    );
  }

  return <Avatar className={className} name={profileData?.email} />;
};

export default UserAvatar;
